import { DOMAIN } from "../../../../../var_env."
import {  setRequestRemoveError, setRequestRemoveData, setRequestRemoveLoading, setRequestRemoveMessage } from "../Reducers/VazaoLancamentoReducer"
import { RequestResponsePattern } from "../../../../../types/Request"
import { deleteApi } from "../../../../../utils/requestApi"
import { vazaoLancamento } from "../types"
// import { setAlert } from "../../../../../store/reducers/alert/alertReducer"
// import createAlert from "../../../../../scripts/alert/createAlert"

export default async function remove(dispatch: Function, values: any){
    try {
        dispatch(setRequestRemoveLoading())
        
        const endpoint = `${DOMAIN}/PessoaHidrometroLancamento`
        const params = { id: values.id, idUsuario: values.idUsuario }
        const response: RequestResponsePattern<vazaoLancamento> = await deleteApi({ endpoint, params })
        
        if(response){
            dispatch(setRequestRemoveData(response))
            if(!response.flagErro) dispatch(setRequestRemoveData(response))
            else throw new Error(response.listaMensagens[0])
        }else throw new Error('Erro na requisição')

    } catch (error: any) {
        dispatch(setRequestRemoveMessage(error.message ?? JSON.stringify(error)))
        dispatch(setRequestRemoveError())
    }
}